import { Button } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import IconLabel from '@fmbt/ui/IconLabel';
import { AntSwap, FiChevronLeft, FiRotateCcw } from '@fmbt/ui/icons';
import { VStack } from '@fmbt/ui/layout';
import Tabs from '@fmbt/ui/Tabs';
import PageHeaderPusher from 'components/atoms/PageHeaderPusher';
import { RestoreTabContent, TransferTabContent } from 'components/features/backOffice/BackOfficeOperationsDataTransfer';

function BackOfficeOperationsDataTransfer(): JSX.Element {
  const navigate = useNavigate();

  const tabItems = [
    {
      key: 'transfer',
      label: (
        <IconLabel
          icon={<AntSwap style={{ margin: 0 }} />} // overrides `.ant-tabs-tab .anticon { margin-right: 12px }`
          label="Transfer"
          gap={12}
        />
      ),
      children: <TransferTabContent />
    },
    {
      key: 'restore',
      label: (
        <IconLabel
          icon={<FiRotateCcw />}
          label="History"
          gap={12}
        />
      ),
      children: <RestoreTabContent />
    }
  ];

  return (
    <PageHeaderPusher ds enterpriseScoped={false}>
      <VStack preset="page">
        <Button
          type="link"
          onClick={() => navigate('/back-office/operations')}
          style={{ padding: 0 }}
        >
          <IconLabel
            icon={<FiChevronLeft size={22} />}
            label="Back to operations"
            gap={4}
          />
        </Button>
        <Tabs items={tabItems} />
      </VStack>
    </PageHeaderPusher>
  );
}

export default BackOfficeOperationsDataTransfer;
